import enums from "../enums";
import Service from "../service/index.jsx";

export function getAppBonuses(data, cb) {
	return (dispatch) => {
		dispatch({ type: enums.APP_BONUS_LOADING, payload: true });
		dispatch({ type: enums.CASINO_GAMES_LOADING, payload: true });
		Service.get("bonus-api", "bonus", data)
			.then((response) => {
				dispatch({ type: enums.APP_BONUS_LIST, payload: response.data });
				dispatch({ type: enums.APP_BONUS_LOADING, payload: false });
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
				cb(response.data);
			})
			.catch((e) => {
				console.log(e);
				dispatch({ type: enums.APP_BONUS_LOADING, payload: false });
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
			});
	};
}

export function getVisibleAppBonuses(data, cb) {
	return (dispatch) => {
		dispatch({ type: enums.APP_BONUS_LOADING, payload: true });
		dispatch({ type: enums.CASINO_GAMES_LOADING, payload: true });
		Service.get("bonus-api", "bonus/visible", data)
			.then((response) => {
				dispatch({ type: enums.APP_VISIBLE_BONUS_LIST, payload: response.data });
				dispatch({ type: enums.APP_BONUS_LOADING, payload: false });
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
				cb(response.data);
			})
			.catch((e) => {
				console.log(e);
				dispatch({ type: enums.APP_BONUS_LOADING, payload: false });
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
			});
	};
}

export function getUserAvailableBonuses(params, cb) {
	return (dispatch) => {
		dispatch({ type: enums.GET_USER_AVAILABLE_BONUSES_LOADING, payload: true });
		Service.get("bonus-api", "userClaims", params)
			.then((response) => {
				dispatch({
					type: params.offset
						? enums.UPDATE_USER_AVAILABLE_BONUSES_SUCCESS
						: enums.GET_USER_AVAILABLE_BONUSES_SUCCESS,
					payload: response.data,
				});
				dispatch({ type: enums.GET_USER_AVAILABLE_BONUSES_LOADING, payload: false });
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.GET_USER_AVAILABLE_BONUSES_LOADING, payload: false });
				dispatch({ type: enums.GET_USER_AVAILABLE_BONUSES_ERROR, payload: false });
			});
	};
}

export function getUserBonusHistory(params, cb) {
	return (dispatch, getState) => {
		dispatch({ type: enums.GET_USER_AVAILABLE_BONUSES_LOADING, payload: true });
		Service.get("transaction-api", "user/payments", params)
			.then((response) => {
				dispatch({
					type: params?.params?.lastItem
						? enums.UPDATE_LIST_BONUS_HISTORY
						: enums.LIST_BONUS_HISTORY,
					payload: { ...response.data, wagering: getState().balance.wagering },
				});
				dispatch({ type: enums.GET_USER_AVAILABLE_BONUSES_LOADING, payload: false });
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.GET_USER_AVAILABLE_BONUSES_LOADING, payload: false });
				dispatch({
					type: enums.ALERT_IN,
					payload: {
						type: "error",
						msg: "GENERIC_ERROR",
						title: "ERROR",
					},
				});
			});
	};
}

export function userDeposit(id, timestamp, cb) {
	return (dispatch) => {
		dispatch({ type: enums.GET_USER_AVAILABLE_BONUSES_LOADING, payload: true });
		Service.post("bonus-api", `bonus/userdeposit/${id}?timestamp=${timestamp}`)
			.then((response) => {
				dispatch({ type: enums.GET_USER_AVAILABLE_BONUSES_LOADING, payload: false });
				if (cb) {
					cb(response);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.GET_USER_AVAILABLE_BONUSES_LOADING, payload: false });
				dispatch({
					type: enums.ALERT_IN,
					payload: {
						type: "error",
						msg: "GENERIC_ERROR",
						title: "ERROR",
					},
				});
			});
	};
}

export function triggerBonus(id, data, cb) {
	return (dispatch) => {
		Service.post("bonus-api", `bonus/${id}/trigger`, data)
			.then((response) => {
				dispatch({ type: enums.GET_ACTIVE_BONUS_PRESENT_LOADING, payload: false });
				if (cb) {
					cb();
				}
			})
			.catch((e) => {
				dispatch({ type: enums.GET_ACTIVE_BONUS_PRESENT_LOADING, payload: false });
				dispatch({
					type: enums.ALERT_IN,
					payload: {
						type: "error",
						msg: "GENERIC_ERROR",
						title: "ERROR",
					},
				});
			});
	};
}
export function getActivePresentBonuses(cb, errCb) {
	return (dispatch) => {
		dispatch({ type: enums.GET_ACTIVE_BONUS_PRESENT_LOADING, payload: true });
		Service.get("bonus-api", "activeBonusWheel")
			.then((res) => {
				dispatch({ type: enums.GET_ACTIVE_BONUS_PRESENT_LOADING, payload: false });
				dispatch({ type: enums.GET_ACTIVE_BONUS_PRESENT_LIST, payload: res.data });
				if (cb) {
					cb(res.data);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.GET_ACTIVE_BONUS_PRESENT_LOADING, payload: false });
				dispatch({
					type: enums.ALERT_IN,
					payload: {
						type: "error",
						msg: "GENERIC_ERROR",
						title: "ERROR",
					},
				});
				errCb(e);
			});
	};
}
export function getBonusById(id, cb) {
	return (dispatch) => Service.get("bonus-api", `bonus/${id}`).then((res) => cb(res));
}
export function clickBonusWheel(data, cb) {
	console.log(data);
	return (dispatch) => {
		dispatch({ type: enums.GET_ACTIVE_BONUS_PRESENT_LOADING, payload: true });
		Service.post("bonus-api", "clickBonusWheel", data)
			.then((response) => {
				dispatch({ type: enums.GET_ACTIVE_BONUS_PRESENT_LOADING, payload: false });

				if (cb) {
					cb(response && response.data);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.GET_ACTIVE_BONUS_PRESENT_LOADING, payload: false });
				dispatch({
					type: enums.ALERT_IN,
					payload: {
						type: "error",
						msg: "GENERIC_ERROR",
						title: "ERROR",
					},
				});
			});
	};
}

export function getBonusClickByUser(cb, errCb) {
	return (dispatch) => {
		Service.get("bonus-api", "clickBonusWheel")
			.then((res) => {
				if (
					res?.data?.remainingTotalClaims === 0 ||
					res?.data?.description === "Unexpected Error"
				)
					dispatch({ type: enums.PRESENT_BOX_VISIBILITY, payload: false });
				else dispatch({ type: enums.PRESENT_BOX_VISIBILITY, payload: true });
				dispatch({ type: enums.GET_ACTIVE_BONUS_CLICK_TIME, payload: res.data });
				if (cb) {
					cb(res.data);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.PRESENT_BOX_VISIBILITY, payload: false });
				if (errCb) {
					errCb(e);
				}
			});
	};
}
export const checkReality = (cb, errCb) => {
	return Service.post("bonus-api", "cashback/realitycheck", { lossCalcHoursLast: "1" })
		.then((res) => {
			if (cb) {
				cb(res.data);
			}
		})
		.catch((e) => {
			if (errCb) {
				errCb(e);
			}
		});
};
